<ng-container *transloco="let t; read: 'email'">
	<form-wrapper [header]="t('titleConfirmation')" *ngIf="!processingRequest; else loading">
		<div *ngIf="!emailConfirmed; else done">
			<div class="flex mti-7 gapi-5">
				<app-button (click)="confirmEmail()">
					{{'buttons.next' | transloco}}
				</app-button>
				<app-button appearance="outline" routerLink="/login" queryParamsHandling="preserve">
					{{'buttons.cancel' | transloco}}
				</app-button>
			</div>
		</div>
		<ng-template #done>
			<div class="app-text__body-m mbi-7">{{t('emailConfirmed')}}</div>
			<app-button appearance="outline" routerLink="/login" queryParamsHandling="preserve">
				{{'buttons.ok' | transloco}}
			</app-button>
		</ng-template>
	</form-wrapper>
</ng-container>

<ng-template #loading>
	<div class="flex flex-jc-center mti-19">
		<app-loader [loading]="true">
		</app-loader>
	</div>
</ng-template>